var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "auth-message" }, [
    _c("h1", [_vm._v("\n    " + _vm._s(_vm.header) + "\n  ")]),
    _c(
      "p",
      [
        _vm._t("details", function () {
          return [_vm._v("\n      " + _vm._s(_vm.detailsText) + "\n    ")]
        }),
      ],
      2
    ),
    !_vm.isUserLoggedIn
      ? _c(
          "p",
          [
            _c("KExternalLink", {
              attrs: {
                text: _vm.linkText,
                href: _vm.signInLink,
                appearance: "basic-link",
                "data-test": "signinlink",
              },
            }),
          ],
          1
        )
      : _c(
          "p",
          [
            _c("KExternalLink", {
              attrs: {
                text: _vm.$tr("goBackToHomeAction"),
                href: _vm.rootUrl,
                appearance: "basic-link",
                "data-test": "gohomelink",
              },
            }),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }